import type {
  Conversation,
  Media,
  Message,
  Participant,
  User,
} from "@twilio/conversations";

import type {
  ChatConversation,
  ChatMedia,
  ChatMessage,
  ChatParticipant,
  ChatUser,
} from "./types";

export const conversationsMap = new Map<string, Conversation>();
export const messagesMap = new Map<string, Message>();
export const usersMap = new Map<string, User>();
export const mediaMap = new Map<string, Media>();
export const participantsMap = new Map<string, Participant>();

const capitalize = (text: string): string =>
  `${text[0]?.toUpperCase()}${text.substring(1)}`;

const getSdkObject = <T>(
  objectMap: Map<string, T>,
  sid: string,
  type: "conversation" | "message" | "participant" | "user" | "media",
): T => {
  const sdkObject = objectMap.get(sid);
  if (!sdkObject) {
    throw new Error(`${capitalize(type)} with SID ${sid} not found`);
  }
  return sdkObject;
};

export const getSdkConversationObject = (
  chatConversation: ChatConversation,
): Conversation =>
  getSdkObject(conversationsMap, chatConversation.sid, "conversation");

export const getSdkMessageObject = (chatMessage: ChatMessage): Message =>
  getSdkObject(messagesMap, chatMessage.sid, "message");

export const getSdkUserObject = (chatUser: ChatUser): User =>
  getSdkObject(usersMap, chatUser.identity, "user");

export const getSdkMediaObject = (chatMedia: ChatMedia): Media =>
  getSdkObject(mediaMap, chatMedia.sid, "media");

export const getSdkParticipantObject = (
  chatParticipant: ChatParticipant,
): Participant =>
  getSdkObject(participantsMap, chatParticipant.sid, "participant");
